import { useCallback, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useNotification } from 'src/contexts/notification.context'
import { useResource } from 'src/hooks/useResource'
import {
  getResourceRequest,
  updateResourceRequest,
} from 'src/services/api.service'
import { BackLink } from 'src/components/common'
import { routes } from 'src/navigation/routes'
import PracticeForm from './form'

export const TeacherEditPractice = () => {
  const history = useHistory()
  const { id } = useParams()
  const { wrapCallback } = useNotification()
  const [values, setValues] = useState(null)
  const [error, setError] = useState('')

  const { resourceType, resourceName, resourceCode } = useResource()

  useEffect(() => {
    fetchData()
  }, [id])

  const fetchData = useCallback(async () => {
    wrapCallback(async () => {
      const response = await getResourceRequest(resourceType, id)
      setValues(response.data.item)
    })
  }, [])

  const onSubmit = async (values) => {
    wrapCallback(async () => {
      await updateResourceRequest(resourceType, id, {
        type: resourceCode,
        ...values,
      })
      console.log('LInk', routes[resourceType].questions.index(id))
      history.push(routes[resourceType].questions.index(id))
    })
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes[resourceType].index} />
        <h2 className="sectionHb-title">
          Edit {resourceName}:{' '}
          <span className="blue__text">Prepare manually</span>
        </h2>
      </div>

      <div className="sectionHb-block">
        <div className="sectionHb-block__wrap">
          {values && (
            <PracticeForm
              initialValues={values}
              onSubmit={onSubmit}
              error={error}
            />
          )}
        </div>
      </div>
    </>
  )
}
